import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-provided.png'
import _imports_1 from '@/assets/logo-invert-provided.png'


const _withScopeId = n => (_pushScopeId("data-v-61c6bf12"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navWrapper",
  ref: "navigationMod",
  "aria-label": "Main"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Iconomy logo",
  src: _imports_0,
  class: "logoImg"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Iconomy logo",
  src: _imports_1,
  class: "logoImg inverted"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BtnBar" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BtnBar" }, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  class: "blendView",
  ref: "linkView"
}
const _hoisted_9 = { class: "scrollArea" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = {
  class: "navLinks",
  ref: "menuLinkBox"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("about")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("tech policy")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("venture building")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("community building")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" team & partners ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" events ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" news ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("contact")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["navigation mobileNav", {'home':_ctx.$props.isHomepage, 'darkHero':_ctx.$props.darkHero, 'top':_ctx.scrollTop, 'open':_ctx.mobileOpen}]),
      ref: "mobileNav"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "logoPageLink",
          onClick: _ctx.closeMenu
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("div", {
          class: _normalizeClass(["toggleBtn", {'open':_ctx.mobileOpen}]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMenu && _ctx.openMenu(...args)))
        }, _hoisted_7, 2)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                onClick: _ctx.openMenu,
                to: "/about",
                "active-class": "currentPage",
                class: "mainPageLink"
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                onClick: _ctx.openMenu,
                to: "/tech-policy",
                "active-class": "currentPage",
                class: "mainPageLink"
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                onClick: _ctx.openMenu,
                to: "/venture-building",
                "active-class": "currentPage",
                class: "mainPageLink"
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                onClick: _ctx.openMenu,
                to: "/community-building",
                "active-class": "currentPage",
                class: "mainPageLink"
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                onClick: _ctx.openMenu,
                to: "/team",
                "active-class": "currentPage",
                class: _normalizeClass(["mainPageLink", {'currentSubPage' : (_ctx.$route.name === 'TeamDetailView' || _ctx.$route.name === 'PartnerDetailView')}])
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["onClick", "class"]),
              _createVNode(_component_router_link, {
                onClick: _ctx.openMenu,
                to: "/events",
                "active-class": "currentPage",
                class: _normalizeClass(["mainPageLink", {'currentSubPage' : _ctx.$route.name === 'EventDetailView'}])
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["onClick", "class"]),
              _createVNode(_component_router_link, {
                onClick: _ctx.openMenu,
                to: "/news",
                "active-class": "currentPage",
                class: _normalizeClass(["mainPageLink", {'currentSubPage' : _ctx.$route.name === 'NewsDetailView'}])
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["onClick", "class"]),
              _createVNode(_component_router_link, {
                onClick: _ctx.openMenu,
                to: "/contact",
                "active-class": "currentPage",
                class: "mainPageLink"
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 512)
          ])
        ])
      ], 512)
    ], 2)
  ], 512))
}